// extracted by mini-css-extract-plugin
export default {"txt":"styles_txt__o5g26","nextBtn":"styles_nextBtn__heZxx"};